import { render, staticRenderFns } from "./BotaoRastreabilidadeGestaoBungeSubEmpresa.vue?vue&type=template&id=5fed04aa&lang=pug"
import script from "./BotaoRastreabilidadeGestaoBungeSubEmpresa.vue?vue&type=script&lang=js"
export * from "./BotaoRastreabilidadeGestaoBungeSubEmpresa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports